import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Func, TLang } from 'app/services/api5-service/api.interface';
import { PageInfoService } from 'app/services/page-info/page-info.service';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  IFormButtonClickEvent,
  IFormModel,
} from 'common/dynamic-form/dynamic-form.interface';
import { ISPFieldType } from 'common/dynamic-form/model';
import { TemplateConfig } from 'common/dynamic-form/types/template/model';

import { AppService } from './app.service';

@UntilDestroy()
@Component({
  selector: 'isp-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  private currentLanguage = this.pageInfoService.pageInfo.lang;

  readonly loginDoc$ = this.appService.loginDoc$;

  readonly socialData$ = this.appService.socialData$;

  readonly registerData$ = this.appService.registerData$;

  readonly documentsData$ = this.appService.documentsData$;

  readonly copyrightData$ = this.appService.copyrightData$;

  templateConfigs: TemplateConfig[] = [
    {
      type: ISPFieldType.Template,
      props: {
        templateName: 'under-form',
        layoutPlace: 'underForm',
        isHidden$: combineLatest([this.socialData$, this.registerData$]).pipe(
          map(([socialData, registerData]) => !socialData && !registerData),
        ),
      },
    },
    {
      type: ISPFieldType.Template,
      props: {
        templateName: 'page-documents',
        layoutPlace: 'pageFooter',
        isHidden$: this.documentsData$.pipe(map(data => !data)),
      },
    },
    {
      type: ISPFieldType.Template,
      props: {
        templateName: 'page-copyright',
        layoutPlace: 'pageFooter',
        isHidden$: this.copyrightData$.pipe(map(data => !data)),
      },
    },
  ];

  constructor(
    private readonly appService: AppService,
    private readonly pageInfoService: PageInfoService,
  ) {}

  ngOnInit(): void {
    this.appService.fetchInitDoc();
  }

  onButtonClick(event: IFormButtonClickEvent): void {
    const button = event.button;
    if (button.type === 'ok') {
      this.appService.authHandler(event.model, event.button);
    }

    if (button.func === Func.Recovery) {
      this.appService.passwordRecoveryHandler(event.button);
    }
  }

  onChangeModel(model: IFormModel): void {
    const languageInModel = model.lang as TLang;
    if (!this.currentLanguage) {
      this.currentLanguage = languageInModel;
      return;
    }

    if (this.currentLanguage !== languageInModel) {
      this.currentLanguage = languageInModel;
      this.appService
        .changeLanguageHandler$(model)
        .pipe(untilDestroyed(this))
        .subscribe();
    }
  }
}
